import {useState, type FC} from "react"
import {Box, Stack, Typography} from "@mui/material"
import {SupportModal} from "../../components"
import {UnexpectedErrorIcon} from "../../assets/icons"
import {useSearchParams} from "react-router-dom"
import RefreshButton from "../../components/atoms/refreshButton/RefreshButton"
import {Trans, useTranslation} from "react-i18next"

type Props = {
  containerStyle?: React.CSSProperties
  buttonStyle?: React.CSSProperties
  buttonHoverStyle?: React.CSSProperties
}

const Error: FC<Props> = (props) => {
  const [showSupportModal, setShowSupportModal] = useState<boolean>(false)
  const {t} = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const message = searchParams.get("message")
  const containerStyle: React.CSSProperties = {
    ...props.containerStyle,
  }
  const handleNavigate = () => {
    if (searchParams.has("message")) {
      searchParams.delete("message")
      setSearchParams(searchParams)
    }
    window.location.href = "/"
  }
  const handleOpenSupportModal = () => {
    setShowSupportModal((open) => !open)
  }
  const handleCloseSupportModal = () => {
    setShowSupportModal(false)
    handleNavigate()
  }
  return (
    <Box
      component="main"
      height="calc(100vh - 88px)"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{backgroundColor: "#FFF"}}
      style={{...containerStyle}}
    >
      <Stack
        component="section"
        direction="column"
        alignItems="center"
        padding="2rem 1.25rem"
        gap="1.5rem"
        width="34.875rem"
      >
        <Stack
          direction="column"
          gap="1rem"
          component="header"
          alignItems="center"
        >
          <UnexpectedErrorIcon height="2.75rem" width="3.78125rem" />
          <Typography
            component="h1"
            fontSize="1rem"
            fontWeight={700}
            lineHeight="1.25rem"
            color="#224957"
          >
            {t("Unexpected error")}
          </Typography>
        </Stack>
        <Typography
          component="p"
          fontSize="0.875rem"
          fontWeight={400}
          color="#4F5B67"
          textAlign="center"
        >
          <Trans
            i18nKey="We are fixing the error. Please try refreshing your page and contact us if the issue persists."
            defaults="We are fixing the error. Please try refreshing your page and <ContactLink>contact us</ContactLink> if the issue persists."
            components={{
              ContactLink: (
                <Typography
                  component="span"
                  fontWeight={700}
                  color="#226CA5"
                  fontSize="0.875rem"
                  sx={{textDecoration: "underline", cursor: "pointer"}}
                  onClick={handleOpenSupportModal}
                >
                  contact us
                </Typography>
              ),
            }}
          />
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          component="footer"
        >
          <RefreshButton refetch={handleNavigate} />
        </Stack>
      </Stack>
      <SupportModal
        show={showSupportModal}
        handleToggle={handleCloseSupportModal}
        handleSuccess={() => setShowSupportModal(false)}
        title={t("New client support request")}
        relatesToText={t(message || "Unexpected error")}
      />
    </Box>
  )
}

Error.displayName = "Error"

export default Error
